<template>
	<div class="page-wrap login-page">
		<v-card width="600px">
			<v-card-title class="headline grey lighten-2 px-8"> Reset Password </v-card-title>

			<v-divider></v-divider>

			<div class="container px-8">
				<div class="row">
					<div class="col-sm-12">
						<v-text-field label="Username" v-model="username" :error-messages="usernameErrors" @input="$v.username.$touch()" @blur="$v.username.$touch()"></v-text-field>
					</div>
				</div>
			</div>

			<v-card-actions class="headline grey lighten-2 px-8">
                <v-btn color="primary" text link to="/register"> Sign In </v-btn>
				<v-spacer></v-spacer>
				<v-btn @click="submit()" color="primary" text> Reset Password </v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	import './style.scss';

	export default {
		name: 'ForgotPassword',
		components: {},
		mixins: [validationMixin],
		validations: {
			username: { required },
		},
		data: () => {
            return {
				username: ''
            }
		},
		
		computed: {
			usernameErrors () {
				const errors = [];
				if (!this.$v.username.$dirty){
					return errors;
				}

				!this.$v.username.required && errors.push('Username is required');

				return errors;
			}
		},

		methods: {
			submit() {
				this.$v.$touch();
			},

			clear () {
				this.$v.$reset()
				this.password = '';
				this.email = '';
			}
		}
	}
</script>

<style>

</style>
